<template>
  <div class="complaint-section">
    <div class="complaint-section-top">
      <p class="complaint-section-title">
        <span>{{ this.label }}</span>
      </p>
    </div>
    <div class="complaint-section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  // 更多内容区块
  name: 'MoreInfoSection',
  props: {
    label: {
      type: String
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
